export class ApiError extends Error {
    payload: Response | Error;
    constructor(payload: Response | Error) {
        super('');
        Object.setPrototypeOf(this, ApiError.prototype);
        this.payload = payload;
    }
}
